export const borderRadius = {
  none: '0px',
  xs: '8px',
  sm: '14px',
  md: '24px',
  lg: '36px',
  xl: '60px',
  '2xl': '80px',
  '3xl': '100px',
  full: '9999px',
  /** @deprecated alias of '2xl' */
  xxl: '80px',
  circle: '50%',
} as const
